export default __webpack_public_path__ + "static/media/SpaceMono.069a266f.woff";